var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPhoto(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 5.85268C2 5.05384 2.67157 4.40625 3.5 4.40625H12.5C13.3284 4.40625 14 5.05384 14 5.85268V11.9598C14 12.7587 13.3284 13.4062 12.5 13.4062H3.5C2.67157 13.4062 2 12.7587 2 11.9598V5.85268ZM3 9.5881V11.9598C3 12.2261 3.22386 12.442 3.5 12.442H12.5C12.7761 12.442 13 12.2261 13 11.9598V10.231L11.5202 8.80403C11.325 8.61574 11.0084 8.61574 10.8131 8.80403L9.54044 10.0312L9.85355 10.3332C10.0488 10.5215 10.0488 10.8267 9.85355 11.015C9.65829 11.2033 9.34171 11.2033 9.14645 11.015L5.68689 7.67903C5.49162 7.49074 5.17504 7.49074 4.97978 7.67903L3 9.5881ZM9.33333 6.97768C9.33333 7.33272 9.03486 7.62054 8.66667 7.62054C8.29848 7.62054 8 7.33272 8 6.97768C8 6.62264 8.29848 6.33482 8.66667 6.33482C9.03486 6.33482 9.33333 6.62264 9.33333 6.97768Z",
    fill: "#626B7F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPhoto);
export default __webpack_public_path__ + "static/media/icon-photo.6dba95eb49219e18d822b261b7759cd0.svg";
export { ForwardRef as ReactComponent };